// @ts-nocheck
import { EventEmitter } from '@angular/core';
import moment from 'moment-timezone';
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskDateBr {
  public validateEmmiter = new EventEmitter();

  private dateBr = 'DD/MM/YYYY';
  private maxLength = 15;

  public validateAllDigit = false;

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    if (typeof value === 'number') {
      return { newValue: value, newCursorPosition: cursorPosition };
    }
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    return { newValue: newValue.slice(0, 8), newCursorPosition: newCursorPosition };
  }

  // maybe to be DDMMYYYY maybe to be a timestamp or date incomplete
  public setMask(value: any, cursorPosition): { formatedValue; formatedCursorPosition } {
    if (typeof value === 'number') {
      const meuVlaor = moment.utc(value, 'X').tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss');
      const formatedValue = moment.utc(value, 'X').tz('America/Sao_Paulo').format(this.dateBr);

      return { formatedValue: formatedValue, formatedCursorPosition: cursorPosition };
    } else {
      const fator = Math.trunc((cursorPosition - 1) / 2);
      const formatedCursorPosition = (fator > 2 ? 6 : fator * 3) + cursorPosition;

      if (value.length <= 2) {
        const formatedValue = value;
        return { formatedValue, formatedCursorPosition };
      }

      if (value.length <= 4) {
        const formatedValue = value.replace(/^(\d{2})(\d{1,2})/, '$1/$2');
        return { formatedValue, formatedCursorPosition };
      }

      if (value.length <= 8) {
        const formatedValue = value.replace(/^(\d{2})(\d{2})?(\d{1,4})/, '$1/$2/$3');
        return { formatedValue, formatedCursorPosition };
      }

      return { formatedValue: value, formatedCursorPosition };
    }
  }

  public validate(value) {
    if (value.length >= 14 && moment(value, this.dateBr).isValid()) return true;
    else if (typeof value === 'string' && value.length === 8) {
      return true;
    }
    return false;
  }

  public getMaskErrors() {
    return ['DATE_BR'];
  }

  public async formatOutput(value) {
    if (typeof value === 'number') {
      return value;
    } else if (value.length >= 10) {
      const retrn = Number(moment(value, this.dateBr).unix());
      return retrn;
    } else if (value.length === 8) {
      const parsedValue =
        value.substring(4, 8) + '/' + value.substring(2, 4) + '/' + value.substring(0, 2);
      if (moment(parsedValue).isValid()) {
        return Number(moment(parsedValue).unix());
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
}
